<template>
  <div>
    <el-dialog
      title="续费"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="closePay"
      :close-on-click-modal="false"
    >
      <h2 class="tishi">温馨提示</h2>
      <div class="daoqi">你的产品使用已到期，请重新购买</div>
      <div class="alj">若已购买，请稍后重试</div>
      <div>
        亲爱的用户你好，你的云平台服务费已到期，无法使用本产品，如有需要请使用微信扫面下方二维码购买产品。购买产品前请详细阅读购买及使用说明，防止对你造成不便，谢谢！
      </div>
      <div class="product">产品名称：智能发票云平台</div>
      <div class="qrclass"><div id="qrcode"></div></div>
      <div class="flex_cl">
        <el-button type="primary" @click="dialogVisible = false"
          >支付完成</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import store from 'store'
import { USR_TOKEN } from '@/util/const'
import { mapGetters } from 'vuex'
import API from '@/api/api'
export default {
  data() {
    return {
      dialogVisible: true,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.$nextTick(() => {
        this.qrcode()
      })
    },
    //创建二维码
    qrcode() {
      let token = store.get(USR_TOKEN)
      let nsrsbh = '154645464648664' //92510104MA6CNKUP4D
      let id = this.userInfo.id

      //http://192.168.3.19:8080
      //https://www.chinaqjwx.cn/qf_moblie/#/ckzs
      let op = 'qdfp'
      let text =
        'https://www.chinaqjwx.cn/qf_moblie/#/ckzs?op=' +
        op +
        '&nsrsbh=' +
        nsrsbh +
        '&id=' +
        id +
        '&token=' +
        token

      console.log(text)
      let qrcode = new QRCode('qrcode', {
        width: 300, // 设置宽度，单位像素
        height: 300, // 设置高度，单位像素
        text: text, // 设置二维码内容或跳转地址
      })
    },
    closePay() {
      this.$emit('openpaymoney')
    },
  },
}
</script>

<style scoped lang="stylus">
/deep/ .el-dialog__wrapper .el-dialog .el-dialog__body {
  max-height: 1000px;
}
.qrclass {
  width: 100%;
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tishi {
  text-align: center;
}
.daoqi {
  text-align: center;
  color: red;
  font-size: 18px;
}
.alj {
  text-align: center;
  font-size: 18px;
}
.product {
  text-align: center;
  margin-top: 10px;
  font-size: 16px;
}
.flex_cl {
  display: flex;
  justify-content: center;
}
</style>
